import { Component, ViewContainerRef } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { Router } from '@angular/router';
import {LoginService} from '../app/pages/login/login.service';
import moment from 'moment/src/moment';
import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { environment } from '../environments/environment';
declare const gtag: Function;

@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App {

  isMenuCollapsed: boolean = false;
  refreshTimerOnReload;
  timerValue;
  finalValue;
  newtokenTimerObj;
  _authToken;

  constructor(private _state: GlobalState,
              private _imageLoader: BaImageLoaderService,
              private _spinner: BaThemeSpinner,
              private viewContainerRef: ViewContainerRef,
              private themeConfig: BaThemeConfig, 
              private _loginService: LoginService,
              private _router:Router
              ) {

    themeConfig.config();
    this.addAnalyticsScript();
    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
    this._authToken = localStorage.getItem('currentUser');  
    window.onload = (ev) => { 
      var currentTime =  moment()
      var LoginTime = localStorage.getItem('LoginTime');
      if(this._router.url != "/login")
      {
      var datesDiff = currentTime.diff(LoginTime,'seconds',true);
      this.refreshTimerOnReload = datesDiff.toFixed(0) + '000';
      this.timerValue = parseFloat(localStorage.getItem('tokenExpiry'));
      this.finalValue = this.timerValue - this.refreshTimerOnReload;
      var newtokenTimer = Observable.timer(this.finalValue, this.timerValue);
      this.newtokenTimerObj = newtokenTimer.subscribe(t => {
      this._loginService.refreshToken(this._authToken).then((resp) => {
      this._authToken = resp.token;
       localStorage.setItem('currentUser', resp.token)
       localStorage.setItem('LoginTime', moment());
      });
      });        
    }
   }; 
  }
  
  private addAnalyticsScript() {
    let gtagScript: HTMLScriptElement = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.TRACKING_CODE;
        document.head.appendChild(gtagScript);
        if (typeof window !== 'undefined') {
          gtag('config', environment.TRACKING_CODE)
        }
  }

  private _loadImages(): void {
    // register some loaders
    // BaThemePreloader.registerLoader(this._imageLoader.load('assets/img/sky-bg.jpg'));
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts